module.exports = __webpack_public_path__ + "static/media/7.fad2449d.png";